module.exports = __webpack_public_path__ + "img/case1.78cccfa0.png";